import React from 'react';
import { styled, Button } from 'tamagui';

interface SensorWidgetProps {
  action: string;
  icon: React.ReactNode;
  type?: 'default' | 'warning' | 'error';
  onClick?: () => void;
}

export const SensorWidget: React.FC<SensorWidgetProps> = ({ icon, type = 'default', onClick }) => (
  <StyledSensorButton type={type} onPress={onClick}>
    <span>{icon}</span>
  </StyledSensorButton>
);

const StyledSensorButton = styled(Button, {
  display: 'flex',
  alignItems: 'center',
  width: 172,
  height: 172,
  borderWidth: 0,
  borderRadius: 16,
  transition: 'all 0.2s ease',
  cursor: 'pointer',
  pressStyle: { transform: [{ scale: 0.95 }] },
  variants: {
    type: {
      default: {
        backgroundImage:
          'linear-gradient(135deg, rgba(42, 42, 42, 1) 0%, rgba(22, 22, 22, 1) 100%)',
      },
      warning: {
        backgroundImage:
          'linear-gradient(135deg, rgba(255, 115, 0, 1) 0%, rgba(64, 21, 6, 1) 100%)',
      },
      error: {
        backgroundImage: 'linear-gradient(135deg, rgba(206, 15, 21, 1) 0%, rgba(54, 2, 3, 1) 100%)',
      },
    },
  } as const,
});
